import { createFileRoute } from '@tanstack/react-router'

import { FEATURE_LEARNPATH_BLENDED_LEARNING } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'
import { LearnpathsAddElementsEvent } from '@/learnpaths/components/LearnpathsAddElementsEvent/LearnpathsAddElementsEvent'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(event)/create/event',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  const hasLearnpathBlendedLearningFeature = useFeatures(
    FEATURE_LEARNPATH_BLENDED_LEARNING,
  )
  const params = Route.useParams()

  if (!hasLearnpathBlendedLearningFeature) {
    return null
  }

  return <LearnpathsAddElementsEvent mode="create" {...params} />
}
